export default __webpack_public_path__ + "static/media/ic_tokens.f29de2ed.svg";